var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"text-black !absolute right-0 top-9 !rounded-l-3xl !w-52 !py-6 !text-center !text-md font-Handel !shadow-lg !border-r-0 z-50 !capitalize !border-1 hover:!border-black",class:`${_vm.routeLink}_color`,on:{"click":_vm.change}},[_vm._v(" Profile of the month ")])
}
var staticRenderFns = []

export { render, staticRenderFns }